import {UserInfo} from './userInfo';

export interface NewAukceImageParams {
  title: string
  desc?: string
  url: string
  sizeDesc: string
  author: string
  position: number
  initialPrice: number
}

export interface ExistingAukceImageParams {
  id: string
  currentPrice: number,
  priceHistory: {[key: number]: string},
  currentTopper: UserInfo
}

export type AukceImageConstructorParams = NewAukceImageParams & Partial<ExistingAukceImageParams>

export class AukceImage implements NewAukceImageParams, ExistingAukceImageParams {
  id!: string
  currentPrice: number
  desc: string
  priceHistory: {[key: number]: string} = {} // holds emails of toppers in historic order (keyed by price)
  url: string
  title: string
  currentTopper!: UserInfo
  sizeDesc: string
  author: string
  position: number
  initialPrice: number = 200

  constructor(params:  AukceImageConstructorParams) {
    console.log('aukceImage ctor', params);

    this.sizeDesc = params.sizeDesc
    this.desc = params.desc ? params.desc : ''
    this.url = params.url
    this.title = params.title
    this.author = params.author
    this.position = params.position

    if (params.id) this.id = params.id
    this.currentPrice = params.currentPrice || params.initialPrice
    if (params.initialPrice) this.initialPrice = params.initialPrice
    if (params.priceHistory) this.priceHistory = params.priceHistory
    if (params.currentTopper) this.currentTopper = params.currentTopper
  }

}
